import React from 'react';
import { Row, Col } from 'antd';
import { BeraJobSteps } from './BeraJobSteps';
import { BeraJobStepsProvider } from './context';

export function BeraJob() : JSX.Element {
	return (
		<Row>
			<Col xs={24}>
				<BeraJobStepsProvider>
					<BeraJobSteps />
				</BeraJobStepsProvider>
			</Col>
		</Row>
	);
}
